import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import ListGroup from 'react-bootstrap/cjs/ListGroup'
import { _ } from '../../../utils/localization'
import AttendeeListItem from '../../networking/components/AttendeeListItem'
import useSlug from '../../../hooks/useSlug'
import styles from '../../../constants/styles'
import LoadMore from '../../../components/LoadMore'
import {
    getAttendees,
    presentationAttendeesSelector,
    canLoadMoreSelector,
    selectSearch,
    selectLimit,
    loadMore
} from '../presentationAttendeesSlice'
import useSubscribeAttendees from '../../attendees/useSubscribeAttendees'

const S = {
    ListGroup: styled(ListGroup)`
        height: ${({ $isFullScreen }) => ($isFullScreen
        ? 'calc(100vh - 130px)'
        : `calc(100vh - ${styles.topNavHeight}px - 130px)`)}; // 130px is height of top action space
        padding-bottom: 16px;
        overflow-y: auto;
    `,
}

const AttendeeList = ({ hideActions, isFullScreen }: {hideActions?: boolean, isFullScreen?: boolean}) => {
    const dispatch = useDispatch()
    const eventSlug = useSlug('eventSlug')
    const presentationSlug = useSlug('presentationSlug')
    const attendees = useSelector(presentationAttendeesSelector())
    const canLoadMore = useSelector(canLoadMoreSelector())
    const search = useSelector(selectSearch)
    const limit = useSelector(selectLimit)
    useSubscribeAttendees(attendees.map((attendee) => attendee.id))

    useEffect(() => {
        dispatch(getAttendees({
            eventSlug,
            presentationSlug,
            search,
            limit
        }))
    }, [dispatch, eventSlug, presentationSlug, search, limit])

    return (
        <S.ListGroup $isFullScreen={isFullScreen}>
            {
                attendees.map((attendee) => (
                    <AttendeeListItem
                        attendee={attendee}
                        key={attendee.id}
                        hideActions={hideActions}
                    />
                ))
            }
            {canLoadMore && (
                <LoadMore onClick={() => dispatch(loadMore())}>
                    {_('networking.sidebar.load_more_attendees')}
                </LoadMore>
            )}
        </S.ListGroup>
    )
}

export default AttendeeList
